// Redirect to GPA account summary page
// Handles env prefix, lob DetermineClickFunction, account-based routing
// @params accountNumber e.g. "12345C" or "673829"
export function redirectToGpaAccount(accountNumber: string): void {
    const isProd = process.env.NODE_ENV === "production";
    const lob = accountNumber.endsWith("C") ? "commercial" : "personal";
    let redirectionURL = "";
    if (isProd) {
        const connectURL = "https://saconnect.stateauto.com";
        const baseUrl = "https://std-gpa.stateauto.com";
        const fullPath = `${baseUrl}/gpa/html/index.html%23/accounts/${lob}/${accountNumber}/summary`;
        redirectionURL = generateRedirect(
            connectURL,
            fullPath
        );
    } else {
        const subEnv = sessionStorage.getItem("nonprod_env") || "l3-5";
        const gpaBaseURL = "https://std-gpa#env#.stateauto.com";
        const connectBaseURL = "https://saconnect#env#.stateauto.com";
        const gpaURL = `${gpaBaseURL.replace("#env#", "-" + subEnv)}`;
        const fullPath = `${gpaURL}/gpa/html/index.html%23/accounts/${lob}/${accountNumber}/summary`;
        const connectURL = `${connectBaseURL.replace("#env#", "-" + subEnv)}`;
        redirectionURL = generateRedirect(
            connectURL,
            fullPath
        );
    }
    console.log(`[GPA Redirect] -> ${redirectionURL}`);
    window.location.href = redirectionURL;
}

const generateRedirect = (connect_url: string, gpa_url: string) => {
  return `${connect_url}/redirect/links?url=${encodeURIComponent(gpa_url)}&sys=detail_GPA`;
};